import React from 'react'
import ReactDOM from 'react-dom'
import { PageBase } from 'frontend/common-imports'
import ahoy from 'ahoy.js'
import moment from 'lib/moment-timezone-custom'
import Glide, { Controls, Autoplay, Images, Swipe, Breakpoints, Lazy, GLIDE_SETTINGS } from 'frontend/lib/glide/bundle'
import clickToPlayWrap from 'lib/click-to-play-wrap'
import Reviews from 'frontend/pages/rooms/reviews'

// Stolen, fix me )
const s = '.slider__slide img'
const Coverflow = function (e, t, n) {
  const i = {
    tilt (e) {
      e.querySelector(s).style.transform = 'perspective(1500px) rotateY(0deg)'
      this.tiltPrevElements(e)
      this.tiltNextElements(e)
    },
    tiltPrevElements (e) {
      const t = (function (e) {
        const t = []
        if (e) {
          while ((e = e.previousElementSibling)) { t.push(e) }
        }
        return t
      }(e))
      for (let e = 0; e < t.length; e++) {
        const n = t[e].querySelector(s)
        n.style.transformOrigin = '100% 50%'
        n.style.transform = `perspective(1500px) rotateY(${20 * Math.max(e, 2)}deg)`
      }
    },
    tiltNextElements (e) {
      const t = (function (e) {
        const t = []
        if (e) {
          while ((e = e.nextElementSibling)) { t.push(e) }
        }
        return t
      }(e))
      for (let e = 0; e < t.length; e++) {
        const n = t[e].querySelector(s)
        n.style.transformOrigin = '0% 50%'
        n.style.transform = `perspective(1500px) rotateY(${-20 * Math.max(e, 2)}deg)`
      }
    }
  }
  return (n.on(['mount.after', 'run'], () => { i.tilt(t.Html.slides[e.index]) }), i)
}

export default class RoomPage extends PageBase {
  static initPrimaryPhotosSlider () {
    if (this.primarySlider) return

    const selector = '.vr_game_images .game_images_slider'
    if (!document.querySelector(selector)) return

    const plugins = { Coverflow, Breakpoints, Swipe, Images, Controls, Lazy }
    if (document.querySelectorAll(`${selector} .slider__slide`).length > 1) plugins.Autoplay = Autoplay

    this.primarySlider = new Glide(selector,
      Object.assign(
        GLIDE_SETTINGS,
        {
          type: 'slider',
          focusAt: 'center',
          startAt: 1,
          perView: 2,
          gap: 24,
          breakpoints: {
            480: { gap: 10 }
          },
          autoplay: 6000,
          animationDuration: 1000,
          animationTimingFunc: 'ease-in-out',
          hoverstop: true
        }
      )
    ).mount(plugins)
  }

  static destroyPrimarySlider () {
    if (!this.primarySlider) return

    this.primarySlider.destroy()
    this.primarySlider = null
  }

  static initVideo () {
    if (this.videoInitialized) return

    document.querySelectorAll('.video_container .video').forEach(el => clickToPlayWrap(el))
    this.videoInitialized = true
  }

  static initSecondarySlider () {
    if (this.secondarySlider) return

    const selector = '.game_promo .promo_images_slider'
    if (document.querySelectorAll(selector).length === 0) return

    this.secondarySlider = new Glide(selector,
      Object.assign(
        GLIDE_SETTINGS,
        {
          type: 'slider',
          perView: 1,
          gap: 0,
          hoverstop: true
        }
      )
    ).mount({ Swipe, Images, Controls, Autoplay, Lazy })
  }

  static destroySecondarySlider () {
    if (!this.secondarySlider) return

    this.secondarySlider.destroy()
    this.secondarySlider = null
  }

  static async importSchedule () {
    const module = await import('frontend/pages/rooms/vr-room-schedule')

    return module.default
  }

  static async mountRoomSchedule () {
    if (this.roomScheduleMounted) return

    this.roomScheduleMounted = true
    const scheduleComponent = await this.importSchedule()

    ReactDOM.render(
      React.createElement(
        scheduleComponent,
        {
          roomId: parseInt(this.props.roomId),
          openedFrom: moment(this.props.openedFrom),
          prebookingCodeOnly: this.props.prebookingCodeOnly !== undefined
        }
      ),
      document.getElementById('room_schedule_react')
    )
  }

  static handleOtherGamesAppear () {
    this.initOtherGamesSlider()
  }

  static initOtherGamesSlider () {
    if (this.otherGamesSLider) return

    this.otherGamesSLider = new Glide('.other_vr_games .rooms_list',
      Object.assign(
        GLIDE_SETTINGS,
        {
          type: 'carousel',
          perView: 4,
          startAt: window.matchMedia('(min-width: 1439px)').matches ? 2 : 1,
          gap: 46,
          autoplay: 3000,
          animationDuration: 1000,
          animationTimingFunc: 'ease-in-out',
          focusAt: 'center',
          breakpoints: {
            480: { perView: 2, gap: 10 },
            1023: { perView: 2, gap: 30 },
            1439: { perView: 5, gap: 30 }
          }
        }
      )
    ).mount({ Breakpoints, Swipe, Images, Controls, Autoplay })
  }

  static destroyOtherGamesSlider () {
    if (!this.otherGamesSLider) return

    this.otherGamesSLider.destroy()
    this.otherGamesSLider = null
  }

  static handleDOMReady () {
    ahoy.track('$subject_view', { subject_id: this.props.roomId, subject_type: 'Room' })
  }

  static handleStylesApplied () {
    Reviews.init()
    this.onEnter('.videos_container', this.initVideo.bind(this))
    this.onEnter('.vr_game_images', this.initPrimaryPhotosSlider.bind(this))
    this.onEnter('.game_promo', this.initSecondarySlider.bind(this))

    this.onEnter('.schedule_place', () => { this.mountRoomSchedule() })
    setTimeout(() => { this.mountRoomSchedule() }, 3000)
    // this.onEnter('.other_games .rooms_list', this.initOtherGamesSlider.bind(this))
    this.onEnter('.other_vr_games', this.handleOtherGamesAppear.bind(this))
  }

  static get props () {
    return document.body.dataset
  }
}

RoomPage.init()
